import { render, staticRenderFns } from "./chatListView.vue?vue&type=template&id=5880ca11&scoped=true&"
import script from "./chatListView.vue?vue&type=script&lang=js&"
export * from "./chatListView.vue?vue&type=script&lang=js&"
import style0 from "./chatListView.vue?vue&type=style&index=0&id=5880ca11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5880ca11",
  null
  
)

export default component.exports